import React, { memo } from 'react';

import type { FooterProps } from '@sravni/react-footer';
import { Footer as CommonFooter } from '@sravni/react-footer';

import { useSelectFooterSettings } from '@src/reducers/siteSettings';

import styles from './Footer.module.scss';

export const Footer = memo(({ mode = 'default' }: Pick<FooterProps, 'mode'>) => {
  const { support, menu, socialLinks } = useSelectFooterSettings() || {};

  return (
    <CommonFooter className={styles.footer} mode={mode} support={support} menuLinks={menu} socialLinks={socialLinks} />
  );
});

Footer.displayName = 'Footer';
